import React from 'react'
import {makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import moment from 'moment';
import {OfferStatusLabel} from "constants/OfferStatus";
import {OfferEncryptionStatuses, OfferEncryptionStatusLabel} from "constants/OfferEncryptionStatus";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import DateFormats from "constants/DateFormats";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import TooltipIcon from "components/icon/TooltipIcon";
import BoldTypography from "components/BoldTypography";

const useStyles = makeStyles(theme => ({
    root: {},
    cell: {
        padding: theme.spacing(1)
    },
    dateColumn: {
        ...theme.components.table.buttonColumn,
        width: theme.components.table.dateColumn.width + theme.components.table.buttonColumn.width
    },
    buttonColumn: theme.components.table.buttonColumn,
    statusColumn: {
        width: 200,
        paddingRight: theme.spacing(2)
    },
}));

function OfferAdditionalOffersTable(
    {
        additionalOffers,
        redirectToOffer
    }) {
    const classes = useStyles();

    const createItem = ({roundId, supplierId, name, encryptionStatus, status, offerDate, offerDetailsUrl, roundType}, i) => {
        let encIcon = encryptionStatus ? (encryptionStatus === OfferEncryptionStatuses.DECRYPTED ? LockOpenOutlinedIcon : LockOutlinedIcon) : InsertDriveFileOutlinedIcon;
        const dateStr = offerDate ? moment(offerDate).format(DateFormats.DATETIME_FORMAT) : '';

        return [
            name,
            <><TooltipIcon tooltip={OfferEncryptionStatusLabel(encryptionStatus)} Icon={encIcon}/> {status ? OfferStatusLabel(status) : ''}</>,
            dateStr,
            <WorkableIconPreviewButton tooltip={Tr('offer_details')} disabled={!offerDetailsUrl}
                                       onClick={offerDetailsUrl ? () => redirectToOffer(roundType, offerDate) : undefined}/>
        ]
    }


    return (
        <div className={classes.root}>
            {additionalOffers.length === 0 ?
                <BoldTypography>{Tr('additional_offer_collection_pending_info_message')}</BoldTypography>
                :
                <SimpleTable
                    headers={[
                        Tr('name'),
                        Tr('status'),
                        Tr('date_of_receipt'),
                        ''
                    ]}
                    items={
                        additionalOffers.map((item, i) => [
                            ...createItem(item, i)
                        ])
                    }
                    columnClasses={[
                        undefined,
                        classes.statusColumn,
                        classes.dateColumn,
                        classes.buttonColumn
                    ]}
                    cellClassName={classes.cell}
                />}
        </div>
    )
}

OfferAdditionalOffersTable.propTypes = {
    additionalOffers: PropTypes.array.isRequired,
}

export default OfferAdditionalOffersTable;
